enum Fields {
    Email = 'Email Address',
    Password = 'Password',
}

export default Fields;
